<template>
  <ElCard
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-background="rgba(0, 0, 0, 0.35)"
    :class="s.baby"
  >
    <div class="one">
      <div class="child">
        <span class="must-check">*</span>姓名：
        <ElSelect
          v-model="child"
          allow-create
          filterable
          class="w120"
          placeholder="请选择"
          :remote-method="remoteMethod"
          remote
        >
          <ElOption
            v-for="item in optionsChildren"
            :key="item.id"
            :label="item.child_name"
            :value="item.id"
          ></ElOption>
        </ElSelect>
      </div>
      <template v-if="childInfo">
        <div class="child">
          年龄：{{ childInfo.age || childInfo.birthday_text }}
        </div>
        <div class="child">性别：{{ childInfo.sex_text || childInfo.sex }}</div>
        <div class="child">电话：{{ childInfo.parent_tel }}</div>
      </template>
      <template v-else>
        <div class="child">
          <span class="must-check">*</span>生日：
          <ElDatePicker
            v-model="birthday"
            type="date"
            prefix-icon="dd"
            class="w120"
            placeholder
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickOptions"
            @change="changeEditStatus(true)"
          ></ElDatePicker>
        </div>
        <div class="child">
          <span class="must-check">*</span>性别：
          <ElRadioGroup v-model="sex" @change="changeEditStatus(true)">
            <ElRadioButton :label="1">男</ElRadioButton>
            <ElRadioButton :label="2">女</ElRadioButton>
          </ElRadioGroup>
        </div>
        <div class="child">
          <span class="must-check no-content">*</span>电话：
          <ElInput
            v-model="phone"
            class="float-right w120"
            placeholder
            @change="changeEditStatus(true)"
          ></ElInput>
        </div>
      </template>
    </div>
    <div v-if="childInfo" class="two">
      <div class="child">身高：{{ childInfo.height || '' }}</div>
      <div class="child">体重：{{ childInfo.weight || '' }}</div>
      <div class="child">体质：{{ childInfo.body_name || '' }}</div>
      <div class="child">上次评测时间：{{ childInfo.last_time || '' }}</div>
    </div>
  </ElCard>
</template>

<script>
import _ from 'lodash';
import {http, catchAppError} from '@/util';
import {menusNavigation} from '@/store';
import url from '@/config';
import toast from '@/toast';

export default {
  name: 'BabySearch',
  model: {
    prop: 'babyInfo',
    event: 'changeBabyInfo'
  },
  props: {
    babyInfo: {
      type: Object,
      default: () => ({})
    },
    tabName: {
      type: String,
      default: 'Evaluation'
    },
    babyId: {
      type: [String, Number],
      default: ''
    },
    // 该组件是否被评测页使用，因为折整个页面没有路由系统，无法用 URL 判断，故添加此 prop
    isEvaluation: Boolean
  },
  data() {
    return {
      optionsChildren: [],
      listChildLoading: true,
      babySearLoading: false,
      id: '0',
      child: null,
      birthday: '',
      sex: 1,
      children: [],
      phone: '',
      childInfo: null,
      pickOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < Date.now() - 1000 * 60 * 60 * 24 * 365 * 18
          );
        }
      }
    };
  },
  computed: {
    fullscreenLoading() {
      return this.listChildLoading || this.babySearLoading;
    }
  },
  watch: {
    async child(u_id) {
      if (typeof u_id === 'number') {
        this.childInfo = await this.getBabyDetail(u_id).catch(_ => {
          this.childInfo = null;
        });
      } else {
        this.childInfo = null;
      }
      const value = this.childInfo;
      if (value) {
        this.$emit('changeBabyInfo', value);
        return;
      }

      this.$emit('changeBabyInfo', {
        child_name: this.child,
        birthday: this.birthday,
        sex: this.sex,
        tel: this.phone
      });
    },
    babyInfo(value) {
      if (value.isClear) {
        this.clearData();
      }
    },
    babyId: {
      handler() {
        if (+this.babyId && this.children.length) {
          this.babySearLoading = true;
          this.searchBabyById();
        }
      },
      immediate: true
    }
  },
  created() {
    this.$eventHub.$on('add-todo', this.getBabyList);
  },
  mounted() {
    this.getBabyList();
  },
  methods: {
    remoteMethod(query) {
      if (query) {
        this.child = query;
        this.optionsChildren = this.children.filter(item => {
          return item.child_name.includes(query);
        });
      }
    },

    getBabyList() {
      http
        .post(url.testChildList)
        .then(res => {
          this.children = res;
          this.optionsChildren = res;
          this.listChildLoading = false;
          if (+this.babyId) {
            this.babySearLoading = true;
            this.searchBabyById();
          }
        })
        .catch(catchAppError);
    },
    async getBabyDetail(u_id) {
      const url = this.isEvaluation
        ? '/api/test/index/getBaby'
        : '/api/diagnose/consultation/getUserLastRecord';
      const res = await this.$http.post(url, {u_id});
      return res;
    },

    clearData() {
      this.id = '';
      this.child = null;
      this.birthday = '';
      this.sex = 1;
      this.phone = '';
    },
    changeEditStatus(status = true) {
      const tab = menusNavigation.tabs.find(tab => tab.tab === this.tabName);
      tab.isEditing = status;
      this.$emit('changeBabyInfo', {
        child_name: this.child,
        birthday: this.birthday,
        sex: this.sex,
        tel: this.phone
      });
    },
    searchBabyById() {
      this.getBabyDetail(this.babyId)
        .then(res => {
          this.child = res.id;
          this.$emit('changeBabyInfo', {...res});
          this.babySearLoading = false;
        })
        .catch(catchAppError);
    }
  }
};
</script>

<style lang="scss">
// * 号对齐
.one {
  .child {
    height: 40px;
    display: flex;
    align-items: center;
  }

  .must-check {
    position: absolute;
    margin-left: -12px;
  }
}
</style>

<style lang="scss" module="s">
.baby {
  :global {
    width: 100%;
    font-size: 16px;
    .w120 {
      width: 120px;
    }
    .el-card__body .two {
      margin-top: 30px;
    }
    .el-card__body .one,
    .el-card__body .two {
      &.with-tips {
        justify-content: space-between;
      }
      display: flex;
      align-items: center;
      .child {
        margin-right: 20px;
        width: 300px;
        .item-text {
          color: #4b90ff;
        }
        .el-input__inner {
          border-color: #4b90ff;
          color: #4b90ff;
          padding-left: 15px;
          padding-right: 15px;
        }
        .item-icon {
          width: 12px;
          height: 12px;
          background-color: #4b90ff;
          display: inline-block;
          border-radius: 50%;
          margin-bottom: 3px;
          margin-right: 5px;
          vertical-align: middle;
        }
        .el-radio-button {
          margin-right: 10px;
          .el-radio-button__inner {
            border-left: 1px solid #4b90ff;
            border: 1px solid #4b90ff;
            color: #4b90ff;
            border-radius: 20px;
            padding: 7px 15px;
            font-size: 16px;
          }
          .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            background-color: #ffb03e;
            border-left: 1px solid #ffb03e;
            border: 1px solid #ffb03e;
            box-shadow: -1px 0 0 0 #ffb03e;
            color: #fff;
          }
        }
      }
    }
    .float-right {
      vertical-align: middle;
    }
  }
}
</style>
